import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
const Profile = () => {


    const {user} = useAuth0(); 

  return (
    <div className='container mx-auto px-10 my-8'>
        <div className='flex gap-4 items-center'>
             <img src={user.picture} className='rounded-full' alt='user' />
        {/* <h2>{user.name}</h2> */}
        <p>{user.email}</p>
        </div>
    </div>
  )
}

export default Profile